import { styled } from "@mui/material/styles";
import { Link } from 'react-router-dom';

export const StyledLink = styled(Link)(({ theme, size = "medium" }) => ({
  color: theme.palette.typography[200],
  textDecoration: 'none',
  fontWeight: '550',
  '&:hover': {
    textDecoration: 'underline',
  },
}));
